/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaFlowNodeModel, ISchemaFlowNodeTypeDefinitionMap } from "@adapptio/lib-blueprint";

export enum FLOW_EDITOR_LAYOUT {
	VERTICAL = "vertical",
	HORIZONTAL = "horizontal"
}

export interface FlowEditorFlowNodeMetaData {
	wasExecuted?: boolean;
}

export interface INodeInfo {
	typeLabel?: string;
	elementLabel?: string;
	subLabel?: string;
	icon?: string;
}

export type TGetNodeInfoFn<TTypeDefs extends ISchemaFlowNodeTypeDefinitionMap> = (
	modelNode: ISchemaFlowNodeModel<TTypeDefs>
) => INodeInfo;
